import styled from 'styled-components';

// Styles
export const Root = styled.div`
	min-height: 50vh;
	box-sizing: border-box;
    margin: 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
	overflow: hidden !important;
	direction: rtl;
	button, input {
		font-family: Samim !important;
	}
	direction: ${p => p.webConfig.dir} !important;
	font-family: ${p => p.webConfig.fontFamily} !important;
	button, input {
		font-family: ${p => p.webConfig.fontFamily} !important;
	}
	${p => !p.footerVisibility && `
		min-height: 0;
		height: 100vh;
		@media (max-width: 600px) {
			height: 90vh;
		}
	`}
	.children {
		min-height: 50vh;
		position: relative;
		top: 57px;
		background: #F5F5F7;
		${p => p.webview || !p.headerVisibility && `
			top: 0;
			min-height: 0;
			height: 100%;
		`}
	}
`;